import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceDeliveryTypeSelectorButton from '@/components/Ui/ServiceDeliveryTypeSelectorButton'
import ServiceNoticeTypeSelectorButton from '@/components/Ui/ServiceNoticeTypeSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsViewerMode',
  components: {
    FileSelectorButton,
    ServiceDeliveryTypeSelectorButton,
    ServiceNoticeTypeSelectorButton,
  },
  data () {
    return {
      inited: false,
      
      // input
      input: {
        viewerModeUseFlg: 0,
        deliveryTypes: [],
        noticeTypes: [],
        viewerTopImageFile: null,
        weatherContentsShowFlg: 0,
        viewerTopDisplayInterval: null,
        contentsDisplayInterval: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    viewerModeUseList () {
      return Constants.ServiceContents.ViewerModeUse.sort(Utility.sortByKey('index', true))
    },
    weatherContentsShowList () {
      return Constants.ServiceContents.WeatherContentsShow.sort(Utility.sortByKey('index', true))
    },
    weatherContentsDisplayIntervalList () {
      return Constants.ServiceContents.WeatherContentsDisplayInterval
    },

    // enable
    showDetailItems () {
      return this.input.viewerModeUseFlg === 1
    },
    disableNoticeTypeSelector () {
      return !this.input.deliveryTypes.length
    },

    // validate
    formIsValid () {
      const v1 = this.validate('viewerModeUseFlg')
      if (!v1) return false

      let v2 = false
      if (this.input.viewerModeUseFlg === 1) {
        v2 = this.validate('weatherContentsShowFlg') &&
        this.validate('viewerTopDisplayInterval') &&
        this.validate('contentsDisplayInterval')
      } else {
        v2 = true
      }
      if (!v2) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        viewerModeUseFlg: this.input.viewerModeUseFlg
      }

      // ビューワーモード利用
      if (jsonb.viewerModeUseFlg === 1) {
        jsonb.deliveryTypes = this.input.deliveryTypes
        jsonb.noticeTypes = this.input.noticeTypes
        if (Validator.validFile(this.input.viewerTopImageFile)) {
          jsonb.viewerTopImageFile = this.input.viewerTopImageFile
        }
        jsonb.weatherContentsShowFlg = this.input.weatherContentsShowFlg
        jsonb.viewerTopDisplayInterval = this.input.viewerTopDisplayInterval
        jsonb.contentsDisplayInterval = this.input.contentsDisplayInterval
      }
      
      return jsonb
    },
  },
  watch: {
    'input.deliveryTypes': function (to, from) {
      // 配信タイプが変更されると選択可能なお知らせタイプも変更されるので
      // お知らせタイプの値を初期化する
      if (JSON.stringify(from) !== JSON.stringify(to)) {
        this.$set(this.input, 'noticeTypes', [])
      }
    },
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        console.log('input変更', to)
        this.setValidate({
          key: 'contentsViewerMode',
          value: this.formIsValid
        })
      },
      deep: true
    },
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsViewerMode) {
        let data = $.extend(true, this.input, this.values.contentsViewerMode)
        this.$set(this, 'input', data)
      }

      // 必須項目なし、もしくはラジオボタンのみの場合
      this.setValidate({
        key: 'contentsViewerMode',
        value: true
      })

      this.inited = true
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    /**
     * DeliveryType設定の変更
     */
    changeDeliveryTypeValue (props) {
      console.log('changeDeliveryTypeValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    /**
     * NoticeType設定の変更
     */
    changeNoticeTypeValue (props) {
      console.log('changeNoticeTypeValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'viewerModeUseFlg':
        case 'weatherContentsShowFlg':
          return Validator.validRadio(value)
        case 'contentsDisplayInterval':
          return Validator.validSelect(value)
        case 'viewerTopDisplayInterval':
          return Validator.validText(value)
      }
    },
  }
}
